<div class="web-view">

    <div fxLayout="row" fxLayoutGap="5%" style="margin-top: 10px;margin-bottom: 10px;">
        <div class="logo">
            <a href="/"><img src="assets/images/logo.jpg" alt="creatics_logo" height="45" width="100%" loading="lazy"></a>
        </div>
        <div class="navElements">
            <ul fxLayout="row" class="cus-spacing" style="align-items: center;">
                <li class="dropDownelemets" (click)="showDropdownAbout();$event.stopPropagation()">ABOUT
                    <ul class="card " *ngIf="showDropdownListAbout" fxLayout="column" fxLayoutGap="5px">
                        <li><a href="/about"
                             appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_about_creatics_button',
                            feature_context: 'HEADER'
                            }"
                            > ABOUT CREATICS</a> </li>
                        <li><a href="/team"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_meet_team_button',
                            feature_context: 'HEADER'
                            }"
                            > MEET THE TEAM</a></li>
                        <li><a href="/pricing-and-plans"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_pricing_and_plans_button',
                            feature_context: 'HEADER'
                            }"
                            >PRICING AND PLANS</a> </li>
                        <li><a href="/badges-awards"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_badges_and_awards_button',
                            feature_context: 'HEADER'
                            }"
                            > BADGES AND AWARDS</a></li>
                        <li><a href="/prizes-and-perks"
                              appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_prizes_and_perks_button',
                            feature_context: 'HEADER'
                            }"
                            > PRIZES AND PERKS</a></li>
                    </ul>
                </li>
                <li class="dropDownelemets" (click)="showDropdownDiscover();$event.stopPropagation()">DISCOVER
                    <ul class="card" *ngIf="showDropdownListDiscover" fxLayout="column" fxLayoutGap="5px">
                        <li><a href="/cinejoy/"
                             appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_cinejoy_button',
                            feature_context: 'HEADER'
                            }"
                            >CINEJOY</a> </li>
                        <li><a href="/hitmaker"
                             appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_hitmaker_button',
                            feature_context: 'HEADER'
                            }"
                            >HITMAKER</a> </li>
                        <!-- <li><a href="/our-takes-show">OUR TAKES</a> </li> -->
                        <li><a href="/meet-creatics"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_meet_creatics_button',
                            feature_context: 'HEADER'
                            }"
                            >MEET CREATICS</a> </li>
                    </ul>
                </li>
                <li class="dropDownelemets" (click)="showDropdownEngage();$event.stopPropagation()">ENGAGE
                    <ul class="card" *ngIf="showDropdownListEngage" fxLayout="column" fxLayoutGap="5px">
                        <li><a href="/contest/8"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_fan_cast_it_button',
                            feature_context: 'HEADER'
                            }"
                            >FANS CAST IT</a> </li>
                             <li><a href="/hitmaker"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_hitmaker_button',
                            feature_context: 'HEADER'
                            }"
                                >HITMAKER</a> </li>
                        <li><a href="/cinejoy/"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_cinejoy_experience_button',
                            feature_context: 'HEADER'
                            }"
                            >CINEJOY EXPERIENCES</a> </li>
                        <li><a href="/contest/2"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_pick_the_score_button',
                            feature_context: 'HEADER'
                            }"
                            >PICK THE SCORE</a> </li>
                        <li><a href="/meet-creatics"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_treasures_button',
                            feature_context: 'HEADER'
                            }"
                            >TREASURES</a> </li>
                    </ul>
                </li>
                <li class="dropDownelemets" (click)="showDropdownCreate();$event.stopPropagation()">CREATE
                    <ul class="card" *ngIf="showDropdownListCreate" fxLayout="column" fxLayoutGap="5px">
                        <li><a href="/createyourdreams"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_create_your_dreams_button',
                            feature_context: 'HEADER'
                            }"
                            >CREATE YOUR DREAMS</a> </li>
                        <li><a href="/picture-the-possibilities"
                             appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_picture_the_possibilities_button',
                            feature_context: 'HEADER'
                            }"
                            >PICTURE THE POSSIBILITIES</a> </li>
                        <li><a href="/picture-the-possibilities/ptp-circle"
                             appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_PTP_circle_button',
                            feature_context: 'HEADER'
                            }"
                            >PTP CIRCLE</a> </li>
                            <li><a href="/symposiums/lineup/"
                            appTrackClick 
                            [buttonProps]="{
                            title: 'header_nav_symposiums_button',
                            feature_context: 'HEADER'
                            }"
                                >SYMPOSIUMS</a> </li>
                    </ul>
                </li>
                <li *ngIf="!isUserLogin" class="dropDownelemets">
                
                        <a href="/login" style="color: #6fc2d2;text-decoration: underline;"    
                        appTrackClick
                         [buttonProps]="{
                            title:'header_signin_button',
                            feature_context:'HEADER'
                        }"
                        >SIGN IN</a>

                </li>
                <li *ngIf="isUserLogin" class="dropDownelemets">
                    <div class="userProfile" fxLayout="row" fxLayoutGap="10px">
                        <div class="username">{{name}}</div>
                        <div class="profileImage" *ngIf="setProfilePic">
                            <img src="assets/images/user-icon.png" alt="" (click)="showUserDropdown();$event.stopPropagation()">
                        </div>
                        <div class="profileImage" *ngIf="!setProfilePic">
                            <img src="{{img}}" alt="" (click)="showUserDropdown();$event.stopPropagation()">
                        </div>
                        <div class="dropdown">
                            <button class="btn btn-default dropdown-toggle dropdownIcon" area-expanded="false"
                                (click)="showUserDropdown();$event.stopPropagation()"></button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between">
        <!-- <app-ng-dynamic-breadcrumb [fontSize]="'14px'" style="margin-left: 9vw;"></app-ng-dynamic-breadcrumb> -->
        <!-- <div class="login" fxLayout="row" fxLayoutAlign="end" *ngIf="!isUserLogin">
            <div class="registerLink">
                <a href="/signup">JOIN FREE/</a>&nbsp;
                <a href="/login">SIGN IN</a>
            </div>
        </div> -->

        <!-- <div  class="userProfile" fxLayout="row" fxLayoutGap="10px" *ngIf="isUserLogin">
            <div class="username">{{name}}</div>
            <div class="profileImage" *ngIf="setProfilePic">
                <img src="assets/images/user-icon.png" alt="">
            </div>
            <div class="profileImage" *ngIf="!setProfilePic">
                <img src="{{img}}" alt="" >
            </div>
            <div class="dropdown">
                <button class="btn btn-default dropdown-toggle dropdownIcon" area-expanded="false" (click)="showUserDropdown()"></button>
            </div>
        </div> -->

    </div>
    <!-- <div   *ngIf="isUserLogin">
        <ng-container > -->

    <!-- <div fxLayout="row" fxLayoutAlign="space-between" > -->
    <!-- <div class="registerLink userHome">

                </div> -->



    <!-- </div>
</ng-container>
    </div> -->

    <ng-container *ngIf="isUserLogin && showUserDropdownList">
        <ul class="profileCard">

            <li><a href="/userProfiles/{{userInfo}}?home=false"
                appTrackClick 
                [buttonProps]="{
                title: 'header_nav_my_profile_button',
                feature_context: 'HEADER'
                }"
                >MY PROFILE</a></li>
            <li><a href="/my-inbox"
                 appTrackClick 
                [buttonProps]="{
                title: 'header_nav_my_inbox_button',
                feature_context: 'HEADER'
                }"
                >MY INBOX</a></li>
            <li><a href="/my-account"
                appTrackClick 
                [buttonProps]="{
                title: 'header_nav_my_account_button',
                feature_context: 'HEADER'
                }"
                >MY ACCOUNT</a></li>
            <li><a href="/notifications"
                appTrackClick 
                [buttonProps]="{
                title: 'header_nav_notifications_button',
                feature_context: 'HEADER'
                }"
                >NOTIFICATIONS</a></li>
            <li><a (click)="logoutUser()">LOGOUT</a></li>
        </ul>


    </ng-container>






</div>
<div class="mobile-view" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg>
    <div fxLayout="row" fxLayoutAlign="space-between">
        <div class="hamburger" fxLayout="column" fxLayoutAlign="center">
            <button class="Hamburger-btn" type="button" (click)="showDropDown();$event.stopPropagation()">
                ☰
            </button>

        </div>
        <div class="mobilelogo" fxLayout="column" fxLayoutAlign="center center">
            <a href="/"><img class="mobile_logo" src="assets/images/logo.jpg" alt="creatics_logo" width="90%"></a>
        </div>
        <ng-container *ngIf="isUserLogin">
            <div class="userProfile" fxLayout="row" style="margin-right: 1% !important;">

                <div class="profileImage" *ngIf="setProfilePic">
                    <img src="assets/images/user-icon.png" alt="">
                </div>
                <div class="profileImage" *ngIf="!setProfilePic">
                    <img src="{{img}}" alt="">
                </div>
                <div class="dropdown">
                    <button class="btn btn-default dropdown-toggle dropdownIcon" area-expanded="false"
                        (click)="showUserDropdown();$event.stopPropagation()"></button>
                </div>
            </div>

        </ng-container>
        <ng-container *ngIf="!isUserLogin">
            <div fxLayout="column" fxLayoutAlign="center">
                <div class="registerLink">
                    <!-- <a href="/signup">JOIN FREE/</a>&nbsp; -->
                    <a href="/login"
                    appTrackClick
                         [buttonProps]="{
                            title:'header_signin_button',
                            feature_context:'HEADER'
                        }"
                    >SIGN IN</a>
                </div>
            </div>


        </ng-container>
        <div>
            <ng-container *ngIf="isUserLogin && showUserDropdownList">
                <ul class="mobprofileCard">

                    <li><a href="/userProfiles/{{userInfo}}?home=false">MY PROFILE</a></li>
                    <li><a href="/my-inbox">MY INBOX</a></li>
                    <li><a href="/my-account">MY ACCOUNT</a></li>
                    <li><a href="/notifications">NOTIFICATIONS</a></li>
                    <li (click)="logoutUser()"><a>LOGOUT</a></li>

                </ul>
            </ng-container>
        </div>




    </div>
    <div *ngIf="showMobileDropDown" fxLayout="row" fxLayoutAlign="end">
        <ul class="mobileCard" fxLayout="column" fxLayoutGap="5px">
            <li (click)="showDropdownAbout();$event.stopPropagation()">ABOUT
                <hr>
                <div class="mobileDropdownlist" *ngIf="showDropdownListAbout" fxLayout="column" fxLayoutGap="5px">
            <li><a href="/about"
                appTrackClick 
                [buttonProps]="{
                title: 'header_nav_about_creatics_button',
                feature_context: 'HEADER'
                }"
                > ABOUT CREATICS</a> </li>
            <li><a href="/team"> MEET THE TEAM</a></li>
            <li><a href="/pricing-and-plans">PRICING AND PLANS</a> </li>
            <li><a href="/badges-awards"> BADGES AND AWARDS</a></li>
            <li><a href="/prizes-and-perks"> PRIZES AND PERKS</a></li>
    </div>

    </li>

    <li (click)="showDropdownDiscover();$event.stopPropagation()">DISCOVER
        <hr>
        <div class="mobileDropdownlist" *ngIf="showDropdownListDiscover" fxLayout="column" fxLayoutGap="5px">
    <li><a href="/cinejoy/"
         appTrackClick 
        [buttonProps]="{
        title: 'header_nav_cinejoy_button',
        feature_context: 'HEADER'
        }"
        >CINEJOY</a> </li>
    <li><a href="/hitmaker"
        appTrackClick 
        [buttonProps]="{
        title: 'header_nav_hitmaker_button',
        feature_context: 'HEADER'
        }"
        >HITMAKER</a> </li>
    <!-- <li><a href="/our-takes-show">OUR TAKES</a> </li> -->
    <li><a href="/meet-creatics">MEET CREATICS</a> </li>
</div>


</li>

<li (click)="showDropdownEngage();$event.stopPropagation()">ENGAGE
    <hr>
    <div class="mobileDropdownlist" *ngIf="showDropdownListEngage" fxLayout="column" fxLayoutGap="5px">
<li><a href="/contest/8">FANS CAST IT</a> </li>
<li><a href="/hitmaker">HITMAKER</a> </li>
<li><a href="/cinejoy/">CINEJOY EXPERIENCES</a> </li>
<li><a href="/contest/2">PICK THE SCORE</a> </li>
<li><a href="/meet-creatics">TREASURES</a> </li>

</div>

</li>

<li (click)="showDropdownCreate();$event.stopPropagation()">CREATE
    <hr>
    <div class="mobileDropdownlist" *ngIf="showDropdownListCreate" fxLayout="column" fxLayoutGap="5px">
<li><a href="/createyourdreams">CREATE YOUR DREAMS</a> </li>
<li><a href="/picture-the-possibilities">PICTURE THE POSSIBILITIES</a> </li>
<li><a href="/picture-the-possibilities/ptp-circle">PTP CIRCLE</a> </li>
<li><a href="/symposiums/lineup/">SYMPOSIUMS</a> </li>
</div>

</li>
</ul>
</div>

</div>

<!-- Meta Pixel Code -->
<script>
    var global = window;
     var path = window.location.origin;
    if(path === 'https://creatics.org' || path === 'https://www.creatics.org'){
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '2158995794424233');
    fbq('track', 'PageView');
    }
    </script>
    <noscript><img height="1" width="1" style="display:none"
    src="https://www.facebook.com/tr?
    id=2158995794424233&ev=PageView&noscript=1"
    /></noscript>
    <!-- End Meta Pixel Code -->